import React, {useEffect, useRef} from "react";
import $ from "jquery";
import PropTypes from "prop-types";

const WithOverlay = (props) => {

  const {children, visible, className, onClick, popupClassName} = props;

  const overlayElement = useRef(null);

  useEffect(() => {
    if (overlayElement && overlayElement.current) {
      $(overlayElement.current).fadeIn(300)
    }
  }, [visible]); // eslint-disable-line react-hooks/exhaustive-deps

  const hideOverlay = (closePopup) => {
    if (overlayElement && overlayElement.current) {
      $(overlayElement.current).fadeOut(300, () => {
        if (closePopup) {
          closePopup();
        }
      })
    }
  };

  const onOverlayClick = (event) => {
    if (!onClick) {
      return;
    }
    if (popupClassName && event.target.closest("." + popupClassName)) {
      return
    }
    hideOverlay(onClick);
  }

  return (
    <div className={"overlay overlay--hidden " + (className || "")}
         ref={overlayElement}
         onClick={onOverlayClick}>
      {children(hideOverlay)}
    </div>
  )
};

WithOverlay.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  onClick: PropTypes.func,
}

export default WithOverlay
